import { render, staticRenderFns } from "./PostDraggableView.vue?vue&type=template&id=6f0db7d9&scoped=true&"
import script from "./PostDraggableView.vue?vue&type=script&lang=ts&"
export * from "./PostDraggableView.vue?vue&type=script&lang=ts&"
import style0 from "./PostDraggableView.vue?vue&type=style&index=0&id=6f0db7d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0db7d9",
  null
  
)

export default component.exports